import {
  AppBar,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  SwipeableDrawer,
  Toolbar,
  styled,
  css,
  Link as HyperLink,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Fragment, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import PopOverIcon from '@/assets/icons/chevron-up-circle.svg?react';
import MailIcon from '@/assets/icons/mail-icon.svg?react';
import Menu from '@/assets/icons/menu.svg?react';
import VielmobilLogo from '@/assets/logos/vielmobil.svg?react';
import { footerLinks } from '@/components/Footer';

const StyledIconButton = styled(IconButton)(
  ({ theme }) => css`
    display: block;

    ${theme.breakpoints.up('md')} {
      display: none;
    }
  `,
) as typeof IconButton;

const StyledAppBar = styled(AppBar)(
  () => css`
    z-index: 100;
  `,
);

const StyledToolbar = styled(Toolbar)(
  () => css`
    display: flex;
    justify-content: space-between;
  `,
);

const StyledSwipeableDrawer = styled(SwipeableDrawer)(
  () => css`
    & .MuiPaper-root {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }

    text-transform: uppercase;
    font-weight: bold;
  `,
);

const StyledListItemText = styled(ListItemText)(
  () => css`
    text-align: center;

    & .MuiTypography-root {
      font-weight: bold;
    }
  `,
);

export function MobileNavigation() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawerOpen = () => setDrawerOpen((prevState) => !prevState);

  const location = useLocation();

  const theme = useTheme();
  const show = useMediaQuery(theme.breakpoints.down('md'));

  return show ? (
    <Fragment>
      <StyledAppBar elevation={1} position="relative">
        <StyledToolbar>
          <Link to="/">
            <VielmobilLogo title="www.vielmobil.info" />
          </Link>

          <StyledIconButton aria-label="Menü öffnen" color="inherit" edge="end" onClick={toggleDrawerOpen}>
            <Menu />
          </StyledIconButton>
        </StyledToolbar>
      </StyledAppBar>

      <StyledSwipeableDrawer
        disableSwipeToOpen
        anchor="top"
        onClose={toggleDrawerOpen}
        onOpen={toggleDrawerOpen}
        open={drawerOpen}
      >
        <IconButton onClick={toggleDrawerOpen} sx={{ marginBottom: 3 }}>
          <PopOverIcon />
        </IconButton>
        <Link style={{ marginBottom: 3 }} to="/">
          <VielmobilLogo />
        </Link>
        <List>
          {footerLinks
            .filter(({ to }) => location.pathname !== '/' || to !== '/')
            .map(({ title, to }) => (
              <Fragment key={to}>
                {to ? (
                  <ListItemButton component={Link} to={to}>
                    <StyledListItemText primary={title} />
                  </ListItemButton>
                ) : null}
              </Fragment>
            ))}
        </List>
        <IconButton component={HyperLink} href="mailto:info@ivm-rheinmain.de" sx={{ marginTop: 4 }}>
          <MailIcon />
        </IconButton>
      </StyledSwipeableDrawer>
    </Fragment>
  ) : null;
}
